import React from 'react';
import PropTypes from 'prop-types';
import DataGrid from '../../../../../common/DataGrid/DataGrid.jsx';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '../../../../../common/index.jsx';

const CategoriesTable = ({ wikiCategories, onDelete, onDetailClick }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('Názov'),
      dataIndex: 'name',
      elipsis: true,
      render: (name) => (
        <Tooltip tooltip={name || '-'}>
          <div style={{ width: '100%' }}>{name || '-'}</div>
        </Tooltip>
      ),
    },
    {
      title: t('Počet stránok'),
      dataIndex: 'pages_count',
      width: 150,
      sorter: (a, b) => (a.pages_count || 0) - (b.pages_count || 0),
    },
  ];

  return (
    <DataGrid
      rowKey={(category) => category.id}
      columns={columns}
      dataSource={wikiCategories || []}
      onDelete={onDelete}
      deleteCondition={(category) => !category.pages_count}
      deleteDisabledTooltip={t(
        'Kategóriu nie je možné vymazať, pretože obsahuje wiki stránky',
      )}
      permissionsBasic={'wiki-categories'}
      uniqueTableId={'dynamic-wiki-categories-table'}
      onRowClick={(index) => onDetailClick(index)}
    />
  );
};

CategoriesTable.propTypes = {
  wikiCategories: PropTypes.array,
  onDelete: PropTypes.func,
  onDetailClick: PropTypes.func,
};

export default CategoriesTable;

